import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from 'primereact/button'
import { Column } from 'primereact/column'

import { PanelContainer } from '../../../../components/Panel'
import { DespatchAdviceItem } from '../../../../data/models'
import { getConfigTranslation } from '../../../../utils/helper/getConfigTranslation'
import {
  isRowSelectable,
  rowClassName,
} from '../../../../utils/helper/isRowSelectable'
import { ConfigurableTable, convertOrderItems } from '../../../../utils/wrapper'
import { useConfigContext } from '../../../ui-config/context'
import { useAllDespatchAdviceItems } from '../../data'
import { Edit, Info, Reject } from './dialogs'

type Props = {
  id: string
}

export const Position: React.FC<Props> = ({ id }) => {
  const { t } = useTranslation()

  const { data: despatchAdivceItems, isLoading } = useAllDespatchAdviceItems(id)
  const { uiConfig: config } = useConfigContext()

  const [displayEditItem, setDisplayEditItem] = useState(false)
  const [displayInfoItem, setDisplayInfoItem] = useState(false)
  const [displayRejectItem, setDisplayRejectItem] = useState(false)

  const [itemId, setItemId] = useState('')

  // get items for rejecting or accepting
  const [selectedItems, setSelectedItems] = useState<
    DespatchAdviceItem[] | null
  >()

  const headerTitle = t('despatchAdvice.positions.table.title')
  const headerActions = (
    <Button
      label={t('common.buttons.reject')} // TODO SBI
      onClick={() => setDisplayRejectItem(true)}
      icon="pi pi-times"
      className="p-button-outlined mr-2 mb-2"
      disabled={!selectedItems || !selectedItems.length}
      visible={
        config?.despatchAdvice?.rejectDespatchAdviceItem?.enabled !== false
      }
    />
  )

  // action template
  const actionBodyTemplate = (rowData: DespatchAdviceItem) => {
    return (
      <div className="flex justify-content-end flex-nowrap">
        <Button
          icon="pi pi-times"
          className="p-button-rounded p-button-text"
          onClick={() => {
            setDisplayRejectItem(true)
            setSelectedItems([rowData])
          }}
          disabled={rowData.ConfirmationCode === 'REJECTED'}
          visible={
            config?.despatchAdvice?.rejectDespatchAdviceItem?.enabled !== false
          }
        />

        <Button
          icon="pi pi-info-circle"
          className="p-button-rounded p-button-text mr-2"
          onClick={() => {
            setItemId(rowData.Id)
            setDisplayInfoItem(true)
          }}
          visible={
            config?.despatchAdvice?.infoDespatchAdviceItem?.enabled !== false
          }
        />

        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-text"
          onClick={() => {
            setItemId(rowData.Id)
            setDisplayEditItem(true)
          }}
          visible={
            config?.despatchAdvice?.editDespatchAdviceItem?.enabled !== false
          }
        />
      </div>
    )
  }

  const buttons = <Column key="buttons" body={actionBodyTemplate}></Column>

  return (
    <PanelContainer
      header={
        getConfigTranslation(config.despatchAdvice.positions.title) ??
        t('despatchAdvice.positions.title')
      }
      id="despatchAdvice-position"
      visible={config.despatchAdvice.positions.enabled}
    >
      <>
        <ConfigurableTable
          config={config.despatchAdvice.positions.table}
          data={convertOrderItems(despatchAdivceItems)}
          buttons={buttons}
          headerTitle={headerTitle}
          headerActions={headerActions}
          checkboxen={true}
          selected={selectedItems}
          setSelected={setSelectedItems}
          isDataSelectable={isRowSelectable}
          rowClassName={rowClassName}
          isLoading={isLoading}
          stateKey=""
        />

        <Reject
          visible={displayRejectItem}
          setVisible={setDisplayRejectItem}
          id={id}
          items={selectedItems}
          setSelectedItems={setSelectedItems}
        />

        <Info
          visible={displayInfoItem}
          setVisible={setDisplayInfoItem}
          id={id}
          itemId={itemId}
        />

        <Edit
          visible={displayEditItem}
          setVisible={setDisplayEditItem}
          id={id}
          itemId={itemId}
          setDisplayRejectItem={setDisplayRejectItem}
          setSelectedItems={setSelectedItems}
        />
      </>
    </PanelContainer>
  )
}
